import {CalendarEventId,} from '@business/entities/calendar_event';
import {Endpoint} from '../endpoint';
import {CalendarEventCommentId, CalendarEventCommentResponse} from "@business/entities/calendar_event_comment";

export function fetchEventComments(eventId: CalendarEventId) {
    return Endpoint.get<CalendarEventCommentResponse[]>(`@gc/calendar-event-comments/${eventId}`,);
}

export function createEventComment(eventId: CalendarEventId, message: string) {
    return Endpoint.post<CalendarEventCommentResponse>(`@gc/calendar-event-comments/${eventId}`, {data: {message}});
}

export function updateEventComment(commentId: CalendarEventCommentId, message: string) {
    return Endpoint.patch<CalendarEventCommentResponse>(`@gc/calendar-event-comments/${commentId}`, {data: {message}});
}

export function deleteEventComment(commentId: CalendarEventCommentId) {
    return Endpoint.delete<void>(`@gc/calendar-event-comments/${commentId}`);
}
